document.addEventListener('DOMContentLoaded', function() {
  const getHeadings = document.querySelectorAll('.collection-faq .faqs h4');
  getHeadings.forEach(function(heading) {
    heading.addEventListener('click', function() {
      const getPara = heading.nextElementSibling;
      getPara.classList.toggle('show');
      this.classList.toggle('show')
    });
  });
});
